export default function GaugeLib() {
  return{
    options: {
      el: undefined,
      $el: undefined,
      dialEl: '.gauge__dial-center__indicator',
      $dialEl: undefined,
      maxValue: 100,
      clamp: 100,
      dialStart: 0,
      dialEnd: 360,
      ratio: 1,
      rotation: 0,
      value: 0,
      status: '',
      baseTransform: 'translate3d(-50%,-100%,0)'
    },
    config(data) {
      // console.info('Pre-Config',this.options, data)
      this.options = $.extend({}, this.options, data); // eslint-disable-line

      var o = this.options // Easier to read than this.options

      if(o.el !== undefined) {
        o.$el = $(o.el);  // eslint-disable-line
        o.$dialEl = o.$el.find(o.dialEl)

        if(o.status === 'disabled') {
          o.$el.removeClass('active')
          o.$dialEl.css({
            transform: o.baseTransform + ' rotate(' + o.dialStart + 'deg)' // Set rotation
          })
        } else {
          o.$el.addClass('active')
        }
      }

      if(o.dialStart && o.dialEnd && o.maxValue) {
        var range = (Math.abs(o.dialStart) + o.dialEnd)
        o.ratio = range / o.maxValue
        // console.log('setting ratio', o.ratio);
      }

      // console.info('After-Config',o)
    },
    update(value) {
      var o = this.options // Easier to read than this.options

      if(o.status === 'disabled') {
        return
      }

      o.value = value
      o.rotation = (o.value * o.ratio) + o.dialStart

      if(o.value > o.maxValue) {
        o.rotation = o.dialEnd + 8
      }

      o.$dialEl.css({
        transform: o.baseTransform + ' rotate(' + o.rotation + 'deg)' // Set rotation
      })
    }
  }
}
